// extracted by mini-css-extract-plugin
export default {"root":"classes_root__afSAg","text":"classes_text__iX10M","title":"classes_title__LFU0d"};